import { Trans, useLingui } from '@lingui/react/macro';
import _ from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store/store';
import { UDSelect } from 'ud-form/components/select/component';
import UDButton from 'ud-ui/components/button';
import Modal from 'ud-ui/components/modal';
import UDText from 'ud-ui/components/text';
import { setChampionshipFilter } from 'modules/schedule/store';
import { selectCalendar, selectFilter } from 'modules/schedule/store/selectors';
import { components } from './styles';

function useFilterModal() {
  const { t } = useLingui();
  const dispatch = useDispatch<AppDispatch>();
  const calendar = useSelector(selectCalendar);
  const filter = useSelector(selectFilter);
  const championships = useMemo(() => {
    const matches = Object.values(calendar)
      .flat()
      .map((day) => day.matches)
      .flat();
    return _(matches).map('championship.name').uniq().value();
  }, [calendar]);
  const [isOpen, setIsOpen] = useState(false);

  const [selectedChampionship, setSelectedChampionship] = useState(filter.championship);

  const options = useMemo(() => {
    return [{ value: 'all', label: t`Все` }, ...championships.map((name) => ({ value: name, label: name }))];
  }, [championships, t]);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onOpen = useCallback(() => {
    open();
  }, [open]);

  const onClickSubmit = useCallback(() => {
    dispatch(setChampionshipFilter(selectedChampionship));
    close();
  }, [close, dispatch, selectedChampionship]);

  const component = useMemo(() => {
    return (
      <Modal show={isOpen} onClose={close} size="md">
        <Modal.Body>
          <UDText className="mb-7.5" type={'title-3'}>
            <Trans>Фильтровать по лигам</Trans>
          </UDText>
          <div className={'w-full'} style={{ height: 200 }}>
            <UDSelect
              onChange={(newValue) => setSelectedChampionship(newValue?.value ?? 'all')}
              options={options}
              value={options.find(({ value }) => value === selectedChampionship)}
              components={components}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <UDButton stretch variant={'primary'} onClick={onClickSubmit}>
            <Trans>Применить</Trans>
          </UDButton>
        </Modal.Footer>
      </Modal>
    );
  }, [close, isOpen, onClickSubmit, options, selectedChampionship]);

  return { close, open: onOpen, modal: component };
}

export default useFilterModal;
